module.exports = __webpack_public_path__ + "static/media/logo.1c3120e0.svg";